import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext.js";
import { Cookies } from '../../index.js';
import GradientCard from './GradientCard'; // Import the component
import Language_i18 from '../../js/useNationalLanguage.jsx';
import menuData from './options_global.json';

const TaskList = ({ category }) => {
    const { slug_1 } = useParams();
    const { slug_2 } = useParams();
    const { slug_3 } = useParams();
    const { i18n, lang } = Language_i18();
    const [datahome, set_datahome] = useState({ links: [] });

    useEffect(() => {
        const apikey = Cookies.get('apikey');

        if (category == 'check_scam') {
            set_datahome({
                links: menuData.check_scam
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'check_search') {
            set_datahome({
                links: menuData.check_search
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'savings_coins') {
            set_datahome({
                links: menuData.savings_coins
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'p2p_mmo_main') {
            set_datahome({
                links: menuData.p2p_mmo_main
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'accept_home') {
            set_datahome({
                links: menuData.accept_home
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'p2p_mmo_history') {
            set_datahome({
                links: menuData.p2p_mmo_history
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'p2p_mmo_orders') {
            set_datahome({
                links: menuData.p2p_mmo_orders
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'ai_home_ai') {
            set_datahome({
                links: menuData.ai_home_ai
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (category == 'ai_home_vip') {
            set_datahome({
                links: menuData.ai_home_vip
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'history') {
            set_datahome({
                links: menuData.history_ai
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'home') {
            set_datahome({
                links: menuData.home
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'home_tools') {
            set_datahome({
                links: menuData.home_tools
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'coins') {
            set_datahome({
                links: menuData.e_commerce_coins
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'sellers' && slug_2 == 'home') {
            set_datahome({
                links: menuData.accounts_sellers
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'sellers' && slug_2 == 'shop' && slug_3 == 'home') {
            set_datahome({
                links: menuData.accounts_sellers_shop_home
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'sellers' && slug_2 == 'history' && slug_3 == 'home') {
            set_datahome({
                links: menuData.accounts_sellers_history_home
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'product' && slug_2 == 'home') {
            set_datahome({
                links: menuData.accounts_orders
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_2 == 'home') {
            set_datahome({
                links: menuData.history
                    .map(item => item[lang] || item.en || item.vi)
            });
        } else if (slug_1 == 'home_videos') {
            set_datahome({
                links: menuData.videos_maker
                    .map(item => item[lang] || item.en || item.vi)
            });
        }
    }, [slug_1, slug_2, slug_3, lang]);
    return (
        <>
            <div className="max-w-5xl mx-auto">
                <div className="mt-3 mx-1 grid grid-cols-1">
                    <div className="bg-green-200 bg-opacity-70 p-1 rounded-md shadow-md md:col-span-2">
                        <div className="mt-1 flex flex-wrap ">
                            {
                                datahome &&
                                (<>
                                    {datahome.links.map((link, index) => (
                                        <div className="mb-1 w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                            {
                                                ((slug_1 == 'utility' && slug_2 == 'home') || link.to.includes('https://'))
                                                    ? (<>
                                                        <a href={link.to} key={index} className="no-underline">
                                                            <GradientCard text={link[lang]?.text || link.text} description={link[lang]?.description || link.description} />
                                                        </a>
                                                    </>) : (<>
                                                        <Link to={link.to} key={index} className="no-underline">
                                                            <GradientCard text={link[lang]?.text || link.text} description={link[lang]?.description || link.description} />
                                                        </Link>
                                                    </>)
                                            }
                                        </div>
                                    ))}
                                </>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaskList;
